import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { LayoutService } from '../service/app.layout.service';
import { Drawer } from 'primeng/drawer';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  selector: 'app-rightmenu',
  templateUrl: './app.rightmenu.component.html',
  imports: [Drawer],
})
export class AppRightMenuComponent {
  readonly layoutService = inject(LayoutService);

  public selectedAmount!: SelectItem;

  public amount = [
    { label: '*****24', value: { id: 1, name: '*****24', code: 'A1' } },
    { label: '*****75', value: { id: 2, name: '*****75', code: 'A2' } },
  ];

  public get visible(): boolean {
    return this.layoutService.state.rightMenuVisible;
  }

  public set visible(_val: boolean) {
    this.layoutService.state.rightMenuVisible = _val;
  }
}
